import { memo } from 'react';
import { useSelector } from 'react-redux';

import Linkify from '~/components/Linkify';
import { useExternalLinksClickableContext } from '~/providers/ExternalLinksClickableProvider';
import { centralizedClipDescriptionSelector } from '~/store/centralizedClip/selectors';

export const InfoPanelDescription = memo(() => {
  const description = useSelector(centralizedClipDescriptionSelector);
  const { areExternalLinksClickable } = useExternalLinksClickableContext();

  return (
    <div className="flex w-full items-center justify-between px-2 py-1.5">
      <span className="w-full break-words ads:text-secondary text-14 text-gray-11">
        <Linkify disable={!areExternalLinksClickable}>{description}</Linkify>
      </span>
    </div>
  );
});

InfoPanelDescription.displayName = 'InfoPanelDescription';
